import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User, TierLevel } from 'src/app/models/user';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuNavComponent {
  @Input() data: User;

  @Output() toggleMenu = new EventEmitter<void>();

  on = false;
  TierLevel =  TierLevel;

  toggle(): void {
    this.on = !this.on;

    if (this.on) {
      window.document.body.classList.add('noscroll-mobile');
      this.toggleMenu.emit();
    } else {
      window.document.body.classList.remove('noscroll-mobile');
    }
  }

  dismiss(): void {
    this.on = false;
    window.document.body.classList.remove('noscroll-mobile');
  }
}
